type Params = {
  id_token?: string;
  state: string;
};

export const decodeHashToParams = (hash: string): Params =>
  hash
    .slice(1)
    .split('&')
    .map((p) => p.split('='))
    .reduce(
      (obj, [key, value]) => ({
        ...obj,
        ...(key ? { [key]: decodeURIComponent(value) } : {}),
      }),
      { state: '' }
    );
